namespace $.$$ {
	type $shm_hitalama_surreal_table_config = {
		profile_id?: string
		table?: string
		columns?: readonly string[]
		search_fields?: readonly string[]
	}

	export class $shm_hitalama_map_widget_float_surreal_table extends $.$shm_hitalama_map_widget_float_surreal_table {
		config(): $shm_hitalama_surreal_table_config {
			const data = this.widget().data()
			return data && typeof data === 'object' ? data : {}
		}

		config_patch( patch: Partial< $shm_hitalama_surreal_table_config > ) {
			const next = { ... this.config(), ... patch }
			this.widget().data( next )
			return next
		}

		profile_id( next?: string ) {
			if( next !== undefined ) return this.config_patch({ profile_id: next }).profile_id ?? 'local'
			return this.config().profile_id ?? 'local'
		}

		table_name( next?: string ) {
			if( next !== undefined ) return this.config_patch({ table: next.trim() }).table ?? 'benchmark_entity'
			return this.config().table ?? 'benchmark_entity'
		}

		columns() {
			const columns = this.config().columns
			return columns?.length ? [ ... columns ] : [ 'name', 'status', 'value' ]
		}

		search_fields() {
			const fields = this.config().search_fields
			return fields?.length ? [ ... fields ] : this.columns().filter( name => name !== 'id' )
		}

		columns_text( next?: string ) {
			if( next !== undefined ) {
				const columns = [ ... new Set( next.split( /[,\n]/ ).map( value => value.trim() ).filter( Boolean ) ) ]
				this.config_patch({ columns, search_fields: columns.filter( name => name !== 'id' ) })
				return columns.join( ', ' )
			}
			return this.columns().join( ', ' )
		}
	}
}
